import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import { ecaWorkflowSteps, ecaIndustries } from "../ecaModulesData";

const stepIcons = [
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 3v18M3 12h18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M21 8H3M5 8V20H19V8" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M9 8V5h6v3" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  ),
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="1.5" />
      <path d="M16 16l4.5 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="3" y="6" width="18" height="13" rx="2" stroke="currentColor" strokeWidth="1.5" />
      <path d="M3 10h18" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  ),
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M3 9h13l4 4v8H3V9z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M16 9V5H3" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  ),
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 2l2.5 7.5H22l-6 4.5 2.5 7.5L12 17l-6.5 4.5 2.5-7.5-6-4.5h7.5L12 2z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  ),
];

const EcaHowItWorksSection: React.FC = () => (
  <section className="wdev-tech" aria-labelledby="eca-how-title">
    <div className="container">
      <AnimatedSection className="wdev-section-head wdev-section-head--center">
        <h2 id="eca-how-title" className="wdev-section-head__title">
          How Our E-Commerce App Works
        </h2>
        <p className="eca-section-lead">
          From store setup to delivery and payouts — a complete shopping lifecycle for customers and sellers.
        </p>
      </AnimatedSection>

      <div className="wdev-process__timeline eca-process-timeline">
        <div className="wdev-process__line" aria-hidden="true" />
        {ecaWorkflowSteps.map((step, index) => (
          <motion.div
            key={step.title}
            className="wdev-process__step"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.08 }}
          >
            <div className="wdev-process__badge">{String(index + 1).padStart(2, "0")}</div>
            <div className="wdev-process__card">
              <div className="wdev-process__icon">{stepIcons[index]}</div>
              <h3 className="wdev-process__title">{step.title}</h3>
              <p className="wdev-process__desc">{step.text}</p>
            </div>
          </motion.div>
        ))}
      </div>

      <AnimatedSection className="eca-industries" delay={0.15}>
        <h3 className="eca-industries__title">Industries We Serve</h3>
        <div className="eca-industries__grid">
          {ecaIndustries.map((industry) => (
            <span key={industry} className="eca-industries__tag">
              {industry}
            </span>
          ))}
        </div>
      </AnimatedSection>
    </div>
  </section>
);

export default EcaHowItWorksSection;
